var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardPage',{attrs:{"section":4,"page":10,"nextLabel":"Save","nextDisabled":_vm.nextDisabled}},[_c('comp-4-goals')],1)}
var staticRenderFns = []

export { render, staticRenderFns }